import React from 'react';
import ReactDOM from 'react-dom/client';
import "bootstrap/dist/js/bootstrap.bundle.min";
import "@fortawesome/fontawesome-free/css/all.min.css";
import "bootstrap/dist/css/bootstrap.min.css";

import './index.css';
import reportWebVitals from './reportWebVitals';
import { RouterProvider, useLocation } from 'react-router-dom';
import { Router } from './utilities/Router';

const root = ReactDOM.createRoot(document.getElementById('root'));

root.render(
    <RouterProvider router={Router} />
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
